import PropTypes from "prop-types";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import React from "react";
import Kids from "lib/dataentry/lib/dataentryform/formitems/Kids";

export class Layoutgridcell extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        const config = Object.assign({}, Layoutgridcell.defaultProps.descriptor.config, descriptor.config);
        const Control = config.heading === true ? "th" : "td";
        const classes = [this.selector, "control-layout-gridcell"];
        if (config.controlOnly) {
            classes.push("control-only");
        }
        switch (config.align) {
            case "right":
                classes.push("text-right");
                break;
            case "center":
                classes.push("text-center");
                break;
            case "left":
            default:
                classes.push("text-left");
        }
        return (
            <Control
                key={descriptor.key}
                id={descriptor.id}
                className={classes.join(" ")}
            >
                <Kids {...this.props} controlOnly={config.controlOnly} />
            </Control>
        );
    }

}

Layoutgridcell.defaultProps = {
    descriptor: {
        config: {
            controlOnly: true,
            heading: false,
            align: "left"
        }
    }
};

Layoutgridcell.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes({
        controlOnly: PropTypes.bool,
        heading: PropTypes.bool,
        align: PropTypes.oneOf(["left", "right", "center"])
    }, false, false)),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired
};

export default Layoutgridcell;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Layout/gridcell.js